import type { AccountOwner as GQLItem } from '../../../generated/internal.graphql';

/**
 * The owning user of an account, as the internal (VP staff) schema returns it.
 *
 * Deliberately smaller than AppSchema's `User` — enough to name the owner and to reach their user
 * record, which is all the superadmin account screens ask of it.
 *
 * `name` is nullable, so this cannot use `take` — it skips `undefined` but passes `null` through,
 * which would leak `null` into a `string | undefined` field.
 */
export type AccountOwner = {
  id: number;
  name?: string;
  email: string;
};

export const fromGql = (item: GQLItem): AccountOwner => ({
  id: item.id,
  name: item.name ?? undefined,
  email: item.email,
});
